class ConnecthelpscoutController {
  constructor(User) {
    "ngInject";
    this.name = 'connecthelpscout';
    this.User = User;
  }

  saveApiKey() {

    this.User
      .connectHelpscout(this.apiKey)
      .then((response) => {
        if (response.status === 200) {
          this.dismiss();
          return;
        }
        this.alert = 'Failed to connect helpscout, Please check the api key and try again';
      })
      .catch((err) => {
        this.alert = 'Failed to connect helpscout, Please check the api key and try again';
        console.log(err);
      });
  }

  dismiss() {
    this.dismiss({
      $value: 'cancel'
    });
  }

}

export default ConnecthelpscoutController;



// WEBPACK FOOTER //
// ./client/app/components/home/modals/connecthelpscout/connecthelpscout.controller.js